var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.center)?_c('div',{staticClass:"d-flex align-center justify-center"},[_c('div',{class:`lds-ellipsis${_vm.sizeModifier} ${ _vm.theme === 'light' ? 'light' : '' }`},[_c('div'),_c('div'),_c('div'),_c('div')])]):_c('div',{class:`lds-ellipsis${_vm.sizeModifier} ${ _vm.theme === 'light' ? 'light' : '' }`},[_c('div'),_c('div'),_c('div'),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }